import { render } from "./MobileTerms.vue?vue&type=template&id=166a1d50&scoped=true"
import script from "./MobileTerms.vue?vue&type=script&scoped=true&lang=js"
export * from "./MobileTerms.vue?vue&type=script&scoped=true&lang=js"

import "../../../../assets/css/agreement.css?vue&type=style&index=0&id=166a1d50&scoped=true&lang=css"
import "./MobileTerms.vue?vue&type=style&index=1&id=166a1d50&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-166a1d50"

export default script